import { toast } from "react-toastify";

import AuthService from "./auth.service";

class MessageHandle {
  static error(errorResponse) {
    const config = {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    };

    if (errorResponse.response && errorResponse.response.status === 422) {
      const errors = errorResponse.response.data.errors;
      const key = Object.keys(errors)[0];
      toast.error(errors[key][0], config);
    } else if (
      errorResponse.response &&
      errorResponse.response.status === 401
    ) {
      toast.error(errorResponse.response.data.message, config);
      AuthService.logout();
      window.location.replace("/");
    } else if (errorResponse.response && errorResponse.response.status) {
      toast.error(errorResponse.response.data.message, config);
    } else {
      toast.error(errorResponse, config);
    }
  }

  static success(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  static warning(message) {
    toast.warning(message, {
      theme: "colored",
    });
  }
}

export default MessageHandle;
